import type { Distance } from "../model/distance.ts";
import { distanceFromMillimeters } from "../model/distance.ts";
import type { GenericPosition, GenericSize } from "../model/geom.ts";
import type { PictureConfiguration } from "../model/picture.ts";
import { realWorldBrickSize } from "../model/picture.ts";

type SceneImage = {
	readonly imageSrc: string;
	readonly realWorldSize: GenericSize<Distance>;
	readonly mountBoundsRatios: {
		readonly centrePosition: GenericPosition<number>;
		readonly size: GenericSize<number>;
	};
};

type Scene = {
	readonly id: string;
	readonly name: string;
	readonly fullSize: SceneImage;
	readonly mobileSize: SceneImage;
	readonly minPictureRealWorldSize?: GenericSize<Distance>;
	readonly allowForBrickArt: boolean;
};

// Atm there's an assumption that if compatible with full size then mobile setup will be compatible
function getCompatibleScenes(
	scenes: readonly Scene[],
	{
		numberOfBasePlates,
		basePlateSize,
	}: Pick<PictureConfiguration, "numberOfBasePlates" | "basePlateSize">,
): readonly Scene[] {
	const numberOfBricksWidth = numberOfBasePlates.width * basePlateSize;
	const numberOfBricksHeight = numberOfBasePlates.height * basePlateSize;
	const pictureRealWorldSize = {
		width: distanceFromMillimeters(numberOfBricksWidth * realWorldBrickSize.mm),
		height: distanceFromMillimeters(
			numberOfBricksHeight * realWorldBrickSize.mm,
		),
	};
	return scenes.filter((s) => {
		const mountMaxSize = {
			width: distanceFromMillimeters(
				s.fullSize.realWorldSize.width.mm *
					s.fullSize.mountBoundsRatios.size.width,
			),
			height: distanceFromMillimeters(
				s.fullSize.realWorldSize.height.mm *
					s.fullSize.mountBoundsRatios.size.height,
			),
		};
		if (
			s.minPictureRealWorldSize &&
			pictureRealWorldSize.width.mm < s.minPictureRealWorldSize.width.mm &&
			pictureRealWorldSize.height.mm < s.minPictureRealWorldSize.height.mm
		) {
			return false;
		}
		return (
			mountMaxSize.width.mm >= pictureRealWorldSize.width.mm &&
			mountMaxSize.height.mm >= pictureRealWorldSize.height.mm
		);
	});
}

export { getCompatibleScenes };
export type { Scene, SceneImage };
